export default 'DD/MM/YYYY HH:mm';
